import React from 'react';
import { useComponentRegistry } from '@bem-react/di';
import { cnMessageBar } from './MessageBar.classname';
import { MessageBarClose as Close } from './Close/MessageBar-Close';
import './MessageBar.css';
export * from './MessageBar.classname';
export var MessageBar = function (_a) {
    var className = _a.className, children = _a.children, onClose = _a.onClose, _b = _a.hasIcon, hasIcon = _b === void 0 ? true : _b, type = _a.type;
    var _c = useComponentRegistry(cnMessageBar()), ListTile = _c.ListTile, Icon = _c.Icon;
    var withIcon = hasIcon && type;
    return (React.createElement(ListTile, { className: cnMessageBar(null, [className]), alignItems: "baseline", leftSpace: withIcon ? 'xs' : undefined, rightSpace: onClose ? 'xs' : undefined, leading: withIcon && React.createElement(Icon, { type: type, className: cnMessageBar('Icon') }), trailing: onClose && React.createElement(Close, { onClick: onClose }) },
        React.createElement("div", { className: cnMessageBar('Content') }, children)));
};
